<div class="legal-agreements-component directory-background">
    <div class="container">
        <h1 class="titulo">{{legalAgreements.title}}</h1>
        <div [innerHTML]="legalAgreements.content | safeHtml"></div>
    </div>
</div>
